/**
 * created by mleitzell on 4/4/18.
 * Shared logic of the readonly text prompt input for mobile and desktop web app
 */
import PromptInput from "common/widgets/PromptList/PromptInput";
import ElementNodeType from "common/enums/ElementNodeType";

export default PromptInput.extend({

    options: {
        name: "ReadOnlyPromptInput",
        template: "<span class='readOnlyPrompt'></span>"
    },

    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);
        this._updateStyleType();
        this.refresh();
    },

    /**
     * Override
     */
    setElementStyle: function() {
        PromptInput.fn.setElementStyle.apply(this, arguments);
        var container = this.element.parent();
        container.removeClass([
            ElementNodeType.styleName(ElementNodeType.PARAGRAPH),
            ElementNodeType.styleName(ElementNodeType.HEADING_1),
            ElementNodeType.styleName(ElementNodeType.HEADING_2),
            ElementNodeType.styleName(ElementNodeType.HEADING_3),
            ElementNodeType.styleName(ElementNodeType.HEADING_4)
        ].join(" "));
        container.addClass(ElementNodeType.styleName(this.options.model.textStyle));
    },

    _updateStyleType: function() {
        var style = this.options.model.get("textStyle");
        if (style === ElementNodeType.refName(ElementNodeType.HEADING_1)) {
            this.input.attr("role", "heading");
            this.input.attr("aria-level", "1");
        } else if (style === ElementNodeType.refName(ElementNodeType.HEADING_2)) {
            this.input.attr("role", "heading");
            this.input.attr("aria-level", "2");
        } else if (style === ElementNodeType.refName(ElementNodeType.HEADING_3)) {
            this.input.attr("role", "heading");
            this.input.attr("aria-level", "3");
        } else if (style === ElementNodeType.refName(ElementNodeType.HEADING_4)) {
            this.input.attr("role", "heading");
            this.input.attr("aria-level", "4");
        } else {
            this.input.removeAttr("aria-level");
        }
    },

    updateWidgetValue: function(value) {
        this.input.text(value);
    },

    /**
     * Override
     */
    _focusable: function() {
        // make this input focusable
        if (this.canFocusInitially()) {
            this.input.attr("tabindex", "-1");
        }
    },

    /**
     * Override
     */
    canFocusInitially: function() {
        var index = this.options.model.get("tabIndex");
        return PromptInput.fn.canFocus.call(this) && index !== null && index !== undefined && index >= 0;
    },

    canFocus: function() {
        return false;
    },

    focus: function() {
        this.input.focus();
    },

    /**
     * Override
     * no need to blur this input because the value doesn't change
     */
    _blur: $.noop,

    value: function() {
        return this.input.text();
    }
});
